module.exports = __webpack_public_path__ + "img/undraw_Setup_wizard.3136cd1e.svg";